import { useLocale } from "@/i18n/LocaleContext";

export const Marquee = ({ items = [], className = "" }) => {
  const { t } = useLocale();
  const row = [...items, ...items];
  return (
    <div className={`relative overflow-hidden ${className}`} aria-hidden="true" data-testid="marquee">
      <div className="flex w-max animate-marquee-slow">
        {row.map((item, i) => (
          <span
            key={i}
            className="flex items-center whitespace-nowrap font-display uppercase text-titanium/70"
          >
            <span className="px-8 text-4xl font-extrabold tracking-tight sm:text-6xl lg:text-7xl">
              {t(`marquee.${item}`, item)}
            </span>
            <span className="text-3xl text-signal sm:text-5xl">/</span>
          </span>
        ))}
      </div>
    </div>
  );
};
